export default __webpack_public_path__ + "static/media/emenu-logo-dark.a4ee0ae7.svg";